import * as React from "react";
import { NOT_INSURED_ISSUER_SLUG, USER_INTENT } from "../../../lib/constants";
import AppBody from "../../../components/AppBody";
import Button from "../../../components/connect-ui/Button";
import { SimpleTextPhase } from "../../../components/SimpleTextPhase";
import useCloseClickHandler from "../../../hooks/useCloseClickHandler";
export default function BaseUnqualifiedRoute(_a) {
    var issuer = _a.issuer;
    var closeClickHandler = useCloseClickHandler();
    function handleCloseClick() {
        closeClickHandler({ userIntent: USER_INTENT.PROCEED_MANUALLY });
    }
    return (React.createElement(AppBody, { centerContent: true },
        React.createElement(SimpleTextPhase, { title: "" },
            React.createElement("p", { className: "mb-12 text-center text-lg leading-normal" }, issuer && issuer.id !== NOT_INSURED_ISSUER_SLUG
                ? "Unfortunately, we cannot look up your policy at ".concat(issuer.name, " without an online login.")
                : "Unfortunately, we cannot look up your policy without an online login."),
            React.createElement(Button, { type: "button", "data-cy": "close", onClick: handleCloseClick }, "Close"))));
}
